// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Component: React.LazyExoticComponent<any> = React.lazy(() => import('../components/Dashboard'));

export default class Dashboard extends TabLoader {
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        title: 'Meteo Stations',
        active: true,
        component: Component,
        props: {
          report: 'DASHBOARD_METEO',
          title: 'Dashboard Meteo',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
